import * as React from "react";
import i18n from "../../../i18n";
import { RouteComponentProps } from "react-router";
import { ExportCSVButton } from "react-bootstrap-table";
import { AppContextProps, withAppContext } from "../../../context/AppContext";
import { ResponseError, apiHandleErrorCode } from "../../../utils/ApiBaseConfig";
import { ShipmentEvent } from "../../../interfaces/Event";
import { getShipmentsEvents } from "../../../services/Event";
import { ShipmentEventsTable } from "./event/List";


export interface ShipmentEventsProps extends RouteComponentProps, AppContextProps { }

export interface ShipmentEventsState {
    events: ShipmentEvent[];
    tableOptions: any;
    dateFrom: string;
    dateTo: string;
 }

export class ShipmentEventsMain extends React.Component<ShipmentEventsProps, ShipmentEventsState> {

    constructor(props: ShipmentEventsProps) {
        super(props);
        this.fetchShipmentEvents = this.fetchShipmentEvents.bind(this);
        this.handleFrom = this.handleFrom.bind(this);
        this.handleTo = this.handleTo.bind(this);
        this.state = {
            events: [],
            tableOptions: {
                noDataText: i18n.t('table-empty'),
                sizePerPageList: [{
                    text: '10', value: 10
                }, {
                    text: '20', value: 20
                }, {
                    text: '50', value: 50
                }],
                sizePerPage: 5,
                paginationSize: 3,
                pageStartIndex: 1,
                exportCSVBtn: (onClick: any) => { return <ExportCSVButton btnText={i18n.t('csv-save')} btnContextual='btn-info' onClick={onClick} /> }
            },
            dateFrom: "",
            dateTo: "",
        }
    }

    componentDidMount() {
        var curr = new Date();
        curr.setDate(curr.getDate() + 1);
        var tomorrow = curr.toISOString().substr(0, 10);
        curr.setDate(curr.getDate() - 7);
        var sixDaysBefore = curr.toISOString().substr(0, 10);

        this.setState({ dateFrom: sixDaysBefore, dateTo: tomorrow}, () => {
            this.fetchShipmentEvents();
        });
    }

    fetchShipmentEvents(){
        this.props.showLoading(true);
        getShipmentsEvents(
            this.state.dateFrom !== "" ? this.state.dateFrom : undefined,
            this.state.dateTo !== "" ? this.state.dateTo : undefined
        )
            .then((events: ShipmentEvent[]) => {
                this.setState({ events });
            })
            .catch((response: ResponseError) => {
                apiHandleErrorCode(response.status, this.props.history);
                this.props.setMessage(response.message);
            }).finally(()=> {
                this.props.showLoading(false);
            });
    }

    handleFrom(e: any) {
        e.preventDefault();
        const startDate = e.target.value;
        this.setState({ dateFrom :startDate });
    }

    handleTo(e: any) {
        e.preventDefault();
        const endDate = e.target.value;
        this.setState({ dateTo :endDate });
    }

    render() {
        return (
            <div className="panel-body">
                <div className="card">
                    <div className="card-header">
                        <div className="card-title">
                            <div className="title">{i18n.t('shipment-events')}</div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="form-group col-sm-12">
                            <div className="form-group col-sm-3">
                                <label>{i18n.t('from')}:</label>
                                <input type="date" name="from" className="form-control" id="from" value={this.state.dateFrom} onChange={this.handleFrom} />
                            </div>
                            <div className="form-group col-sm-3">
                                <label>{i18n.t('to')}:</label>
                                <input type="date" name="to" className="form-control" id="to" value={this.state.dateTo} onChange={this.handleTo} />
                            </div>
                            <div className="form-group col-sm-3">
                                <br></br>
                                <button type="button" className="btn btn-info" onClick={this.fetchShipmentEvents}>{i18n.t('search')}</button>
                            </div>
                        </div>
                        
                        <ShipmentEventsTable events={this.state.events} showShipmentEventDetails={true} />
                    </div>
                </div>
            </div>
        )
    }
}

export const ShipmentEvents = withAppContext(ShipmentEventsMain);